import { z } from 'zod';
import { requestIdSchema, timestampSchema, limitIdSchema, preLimitIdSchema, moneySchema, currencySchema, periodSchema, providerType, apiResponseType, } from '@repo/shared/types';
var DISCOUNT_VALIDATE_TYPE = apiResponseType.refine(function (type) { return type === 'DISCOUNT_VALIDATE'; });
// Request
export var discountValidateRequestBodySchema = z.object({
    requestId: requestIdSchema,
    code: z.string(),
    limitId: limitIdSchema.nullable(),
    preLimitId: preLimitIdSchema.nullable(),
    loan: z.object({
        amount: moneySchema,
        currency: currencySchema,
        period: periodSchema,
        pricing: moneySchema,
        loanRepaymentPrice: moneySchema,
        provider: providerType,
        topUp: z.boolean(),
    }),
});
var revenueRateItemSchema = z.object({
    period: periodSchema,
    pricing: moneySchema,
    loanRepaymentPrice: moneySchema,
    amountMax: moneySchema.nullable(),
    amountMin: moneySchema.nullable(),
});
var discountValidateResponseBase = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: DISCOUNT_VALIDATE_TYPE,
});
// Response 200
export var discountValidateResponseSchema = discountValidateResponseBase.extend({
    data: z.object({
        discountEnabled: z.boolean(),
        reasonCode: z.string().nullable().optional(),
        reason: z.string().nullable().optional(),
        limitId: limitIdSchema.nullable().optional(),
        preLimitId: preLimitIdSchema.nullable().optional(),
        availableRevenueRate: z
            .object({
            original: revenueRateItemSchema,
            discounted: revenueRateItemSchema,
        })
            .nullable()
            .optional(),
    }),
});
// Type aliases kept for backwards compatibility with mocks and tests
export var discountValidateSuccessResponseSchema = discountValidateResponseSchema;
// Response 400
export var discountValidateBadRequestResponseSchema = z.object({
    type: z.literal('DISCOUNT_VALIDATE'),
    data: z.object({
        parameter: z.string(),
        errorDescription: z.string(),
    }),
});
// Response 422
export var discountValidateUnprocessableResponseSchema = z.object({
    type: z.literal('DISCOUNT_VALIDATE'),
    data: z.object({
        discountEnabled: z.boolean(),
        reasonCode: z.string(),
        reason: z.string(),
    }),
});
// Response 500
export var discountValidateInternalErrorResponseSchema = z.object({
    type: z.literal('DISCOUNT_VALIDATE'),
    data: z.object({
        errorDescription: z.string(),
    }),
});
